<template>
   <NuxtLayout>
      <NuxtLoadingIndicator color="#c71b1e" />
      <NuxtPage />
   </NuxtLayout>
</template>
